import { render, staticRenderFns } from "./CompanyUserAuthModule.vue?vue&type=template&id=1076967c&scoped=true"
import script from "./CompanyUserAuthModule.vue?vue&type=script&lang=js"
export * from "./CompanyUserAuthModule.vue?vue&type=script&lang=js"
import style0 from "./CompanyUserAuthModule.vue?vue&type=style&index=0&id=1076967c&prod&scoped=true&lang=scss"
import style1 from "./CompanyUserAuthModule.vue?vue&type=style&index=1&id=1076967c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1076967c",
  null
  
)

export default component.exports